import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { EstoqueDBService } from '../database/estoque-db.service';

@Injectable({
  providedIn: 'root'
})
export class EstoqueService extends BaseService{
    override classname: string = 'EstoqueService';
    public override route = 'estoque';
    public override database = new EstoqueDBService();
}
